module.exports = __webpack_public_path__ + "media/images/loghi/lba4you-title-273e3b4474a612a772df8efc0538234c.png";